import React from 'react';

import { Accordion, AccordionSummary, AccordionDetails, withStyles } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

const CustomAccordionRoot = withStyles({
  expanded: {},
  root: {
    '&$expanded': {
      margin: '0px',
    },
    '&:before': {
      display: 'none',
    },
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    backgroundColor: '#00000000',
    border: 'none',
    boxShadow: 'none',
    margin: '0px',
  },
})(Accordion);

const CustomAccordionSummary = withStyles({
  content: {
    '&$expanded': {
      margin: '0px 0px',
    },
    margin: '0px',
  },
  expandIcon: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },
  expanded: {},
  root: {
    '&$expanded': {
      minHeight: 0,
    },
    backgroundColor: '#00000000',
    borderBottom: '0px',
    marginBottom: '0px',
    minHeight: 0,
    padding: '0px',
  },
})(AccordionSummary);

const CustomAccordionDetails = withStyles({
  root: { display: 'block', padding: '0px' },
})(AccordionDetails);

export default ({ title, children, expanded, customIcon, onChange }) => {
  const handleChange = (event, exp) => {
    if (!onChange || typeof onChange !== 'function') return;
    onChange(event, exp);
  };

  return (
    <div>
      <CustomAccordionRoot onChange={handleChange} expanded={expanded}>
        <CustomAccordionSummary expandIcon={customIcon || <ExpandMore />}>{title}</CustomAccordionSummary>
        <CustomAccordionDetails>{children}</CustomAccordionDetails>
      </CustomAccordionRoot>
    </div>
  );
};
